import React from 'react';
import ReactDOM from 'react-dom/client';

import { App } from './App';
import './lib/env'; // Validar variables de entorno al startup

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
